<template>
  <div :class="['d-flex flex-column gap-2 street-view-button', {loaded:!!propertyDetails}]">
    <template v-if="!propertyDetails">
      <button type="button" class="btn btn-primary" @click="lookup" :disabled="loading">
        <spinner-view small v-if="loading" />
        <template v-if="loading">
          Looking up property record for {{ streetViewLabel }}
        </template>
        <template v-else>
          Verify {{ streetViewLabel }}
        </template>
      </button>
    </template>
    <div v-else-if="properties.length === 0">
      We couldn't find any matching property records at {{ streetViewLabel }}.
    </div>
    <template v-else>
      <SuggestedListingProperty
        v-for="property in properties"
        :key="property.id"
        :listing="listing"
        :property="property"
        hide-sync
      />
    </template>
  </div>
</template>

<script>
import {Listing} from "@/models/Listing";
import SpinnerView from "@/components/common/SpinnerView.vue";
import SuggestedListingProperty from "@/components/SuggestedListingProperty.vue";
import {PropertyDetails} from "@/models/PropertyDetails";

export default {
  components: {SuggestedListingProperty, SpinnerView},
  props: {
    listing: Listing,
    streetViewLabel: String
  },
  data() {
    return {
      loading: false,
      properties: null
    }
  },
  watch: {
    listing() {
      this.reset();
    },
    streetViewLabel() {
      this.reset();
    }
  },
  methods: {
    reset() {
      this.loading = false;
      this.properties = null;
    },
    async lookup() {
      this.loading = true;
      try {
        this.properties = await PropertyDetails.searchWithGoogle(this.listing.city, this.streetViewLabel);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style>
.street-view-button.loaded {
  width: 432px;
  max-width: 20vw;
  transition: width 250ms, height 250ms;
}
</style>
